import {
  SEND_FEEDBACK,
  SEND_FEEDBACK_SUCCESS,
  SEND_FEEDBACK_ERROR,
} from "./actionType";

export const sendFeedback = (feedback) => ({
  type: SEND_FEEDBACK,
  payload: feedback,
});
export const sendFeedbackSuccess = (feedback) => ({
  type: SEND_FEEDBACK_SUCCESS,
  payload: feedback,
});
export const sendFeedbackError = (error) => ({
  type: SEND_FEEDBACK_ERROR,
  payload: error,
});
